// @flow

import * as React from 'react';
import { connect } from 'react-redux';

import styles from './styles.scss';

import { preloader, sailAnimationWithoutCaption } from '../../utils/animation';

import { servicesCategories } from '../../utils/variables';

import { CategoryListWrapper } from '../../containers';
import { Category } from '../../components';

import type { CategoryType } from '../../api/types';
import type { DefaultStateType } from '../../redux/reducers';

type Props = {
  categories: Array<CategoryType>,
};

type State = {
  hovered: CategoryType | null,
};

class Rentals extends React.Component<Props, State> {
  state = {
    hovered: null,
  };

  componentDidMount() {
    const callback = () => {
      if (window.innerWidth > 992) {
        sailAnimationWithoutCaption().play();
      }
    };

    preloader(callback).play();

    if (document && document.body) {
      document.body.classList.add('rentals');
    }
  }

  componentWillUnmount() {
    if (document && document.body) {
      document.body.classList.remove('rentals');
    }
  }

  getChildrenNames = (category: CategoryType): string => category.children.map(child => child.name).join(', ');

  render() {
    const { categories } = this.props;
    const { hovered } = this.state;

    if (!categories) {
      return null;
    }

    const rentalCategories = categories.filter(
      category => category.children.length > 0 && !servicesCategories.includes(category.name),
    );

    return (
      <div className={styles['page-wrapper']}>
        <div className="page-cover" />
        <div className={styles.wrap}>
          <div className={styles.title}>
            <h1>rentals</h1>
          </div>
          <div className={styles.description}>
            {hovered ? (
              <React.Fragment>
                <h2 className={styles['category-name']}>{hovered.name}</h2>
                <p className={styles.categories}>{this.getChildrenNames(hovered)}</p>
              </React.Fragment>
            ) : null}
          </div>
        </div>
        <CategoryListWrapper>
          {rentalCategories.map(category => (
            <Category
              key={category.id}
              category={category}
              onMouseEnter={() => this.setState({ hovered: category })}
              onMouseLeave={() => this.setState({ hovered: null })}
            />
          ))}
        </CategoryListWrapper>
      </div>
    );
  }
}

const mapStateToProps = (state: DefaultStateType): { categories: Array<CategoryType> | null } => ({
  categories: state.categories,
});

export default connect(mapStateToProps)(Rentals);



// WEBPACK FOOTER //
// ./src/pages/Rentals/index.js